var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"z-index":1}},[_c('div',{staticClass:"coming-soon-banner"},[_c('v-icon',[_vm._v("mdi-emoticon-happy-outline")]),_c('h5',[_vm._v("Coming soon...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }